"use client";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CareerPathBannerProps {
  onQuizClick?: () => void;
}

export function CareerPathBanner({ onQuizClick }: CareerPathBannerProps) {
  return (
    <div className="rounded-xl bg-slate-100 shadow-md transition-shadow hover:shadow-lg">
      <div className="flex flex-col items-center gap-6 p-6 md:flex-row md:p-8">
        {/* Content */}
        <div className="flex flex-1 flex-col items-start gap-3 text-center md:text-left">
          <h2 className="text-2xl font-bold text-slate-900">
            Find Your Perfect Career Match!
          </h2>
          <p className="text-slate-600">
            Take our fun quiz to discover careers that are a perfect fit for
            your personality and awesome interests.
          </p>
        </div>

        {/* CTA Button */}
        <Button
          onClick={onQuizClick}
          className="flex min-w-[84px] max-w-xs gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full h-12 px-6 text-base font-bold"
        >
          <span>Start A New Journey</span>
          <ArrowRight className="w-5 h-5" />
        </Button>
      </div>
    </div>
  );
}
